import React from 'react'
import './Footer.css'
import { FaFacebook, FaInstagram, FaLinkedin, FaGithub} from 'react-icons/fa'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <footer className="footer">
            <h3>@younes_adda</h3>
            <div className="social-group">
                <Link to={{pathname: 'https://www.facebook.com/younes216/'}} target="_blank"><FaFacebook className="social-icon Facebook" /></Link>
                <Link to={{pathname: 'https://www.instagram.com/younes_adda/'}} target="_blank"><FaInstagram className="social-icon Instagram" /></Link>
                <Link to={{pathname: 'https://www.linkedin.com/in/adda-younes-59132a1a4/'}} target="_blank"><FaLinkedin className="social-icon Linkedin" /></Link>
                <Link to={{pathname: 'https://github.com/addayounes'}} target="_blank"><FaGithub className="social-icon Github" /></Link>
            </div>
        </footer>
    )
}

export default Footer
